import { render, staticRenderFns } from "./CopyTender.vue?vue&type=template&id=a5a5cb88&scoped=true"
import script from "./CopyTender.vue?vue&type=script&lang=js"
export * from "./CopyTender.vue?vue&type=script&lang=js"
import style0 from "./CopyTender.vue?vue&type=style&index=0&id=a5a5cb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a5cb88",
  null
  
)

export default component.exports